export default __webpack_public_path__ + "static/media/building-sign.fcdc7439.svg";